export const letterX = {
  nouns: [],
  verbs: [],
  examples: {
    nominative: [],
    accusative: [],
    dative: [],
    translations: [],
    conjugations: []
  }
}
